<app-loading class="full-screen"></app-loading>